<template>
  <div class="number-stepper">
    <v-text-field
      v-bind="$attrs"
      :model-value="modelValue"
      type="number"
      :step="step"
      :min="min"
      :max="max"
      :disabled="disabled"
      :readonly="readonly"
      @update:model-value="updateValue"
    />
    <div class="number-stepper-controls" aria-label="Ajustar valor">
      <v-btn
        icon="keyboard_arrow_up"
        size="x-small"
        variant="tonal"
        :disabled="disabled || readonly || atMaximum"
        aria-label="Aumentar"
        @click="changeBy(stepNumber)"
      />
      <v-btn
        icon="keyboard_arrow_down"
        size="x-small"
        variant="tonal"
        :disabled="disabled || readonly || atMinimum"
        aria-label="Disminuir"
        @click="changeBy(-stepNumber)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberStepper',
  inheritAttrs: false,
  props: {
    modelValue: [Number, String],
    step: {
      type: [Number, String],
      default: 1
    },
    min: [Number, String],
    max: [Number, String],
    disabled: Boolean,
    readonly: Boolean
  },
  emits: ['update:modelValue'],
  computed: {
    stepNumber () {
      const value = Number(this.step)
      return Number.isFinite(value) && value > 0 ? value : 1
    },
    atMinimum () {
      return this.min !== undefined && this.min !== null && Number(this.modelValue) <= Number(this.min)
    },
    atMaximum () {
      return this.max !== undefined && this.max !== null && Number(this.modelValue) >= Number(this.max)
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('update:modelValue', value)
    },
    changeBy (delta) {
      const current = this.modelValue === '' || this.modelValue === null || this.modelValue === undefined
        ? 0
        : Number(this.modelValue)
      let next = (Number.isFinite(current) ? current : 0) + delta
      if (this.min !== undefined && this.min !== null) next = Math.max(next, Number(this.min))
      if (this.max !== undefined && this.max !== null) next = Math.min(next, Number(this.max))
      const decimals = String(this.stepNumber).split('.')[1]?.length || 0
      this.$emit('update:modelValue', Number(next.toFixed(decimals)))
    }
  }
}
</script>
